import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/configuration", { params });
  },
  save(payload) {
    return http.put("/api/v1/admin/configuration", payload);
  }
};